import * as Sentry from "@sentry/react";

const initSentry = () => {
  const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
  const environment = process.env.NODE_ENV || "development";

  if (sentryDsn) {
    Sentry.init({
      dsn: sentryDsn,
      environment,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: true,
          blockAllMedia: true,
        }),
      ],
      // Performance Monitoring
      tracesSampleRate: environment === "production" ? 0.1 : 1.0,
      // Session Replay
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,

      beforeSend(event, hint) {
        // Filter out some errors if needed
        const error = hint.originalException;

        // Don't send cancelled requests
        if (error && error.message && error.message.includes("cancel")) {
          return null;
        }

        return event;
      },
    });

    console.info("Sentry initialized for environment:", environment);
  } else {
    console.warn("Sentry DSN not provided - error tracking disabled");
  }
};

export default initSentry;
